import OrderDetails from 'components/orders/OrderDetails';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleOrder } from '../../../redux/slices/orders';
import { getData } from 'utilities/common';
import { STILO } from 'utilities/constants';
import OrderStiloDetails from 'components/orders/StiloOrderDetails';

export default function OrderDetailsPage() {
  const dispatch = useDispatch();
  const { orderId = '' } = useParams();
    const adminsMode = getData('adminsMode')
    const isStilo = JSON.parse(adminsMode) === STILO
  useEffect(() => {
    if (orderId) {
      dispatch(fetchSingleOrder(orderId));
    }
  }, [orderId]);
  return (
    <CommonLayout>
      {
        isStilo ?

        <OrderStiloDetails />

        :
        <OrderDetails />

      }
    </CommonLayout>
  );
}
